// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ErrorDetails')

function ErrorDetails(props) {
  return (
    tag('section', {
      className: bem.block()
    },
      tag('header', {
        className: bem.element('header')
      },
        tag('h1', {
          className: bem.element('heading')
        },
          'Error Details'
        )
      ),
      tag('ol', {
        className: bem.element('list')
      },
        props.errors.map((error, index) => (
          tag('li', {
            key: `error:${index}`,
            className: bem.element('item')
          },
            tag('p', {
              className: bem.element('name')
            },
              error.name
            ),
            tag('p', {
              className: bem.element('message')
            },
              error.message
            ),
            tag('p', {
              className: bem.element('stack')
            },
              error.stack
            )
          )
        ))
      )
    )
  )
}

ErrorDetails.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    stack: PropTypes.string.isRequired
  }))
}

module.exports = ErrorDetails
